import store from '../store'

export default class Gugu{
    static is_cosleep () {
        return this.is_cosleep_android() || this.is_cosleep_ios()
      }
    
    // 是否为小睡眠app ios版
    static is_cosleep_ios () {
        let ios = false
        try {
            ios = typeof
            window.webkit.messageHandlers.XinchaoApp !== 'undefined'
        } catch (e) {
            //
        }
        return ios
    }

    // 是否为小睡眠app 安卓版
    static is_cosleep_android () {
        return typeof window.XinchaoApp !== 'undefined'
    }
    
    // 获取小睡眠用户信息
    static getUserInfo(){
      return new Promise((resolve,reject)=>{
        const is_cosleep = this.is_cosleep()
        if(!is_cosleep)
          resolve(false)
        setTimeout(()=>{
          resolve(false)
        },60000)
        this.callAppRouter("Login",{},(error,res)=>{
          console.log("isIPAD:",/iphone|ipad|mac os/.test(navigator.userAgent.toLowerCase()));
          const info = /iphone|ipad|mac os/.test(navigator.userAgent.toLowerCase())?JSON.parse(res):res
          // const first = sessionStorage.getItem("firstGetCosleepInfo")
          // if(!first)
          //   sessionStorage.setItem("firstGetCosleepInfo","no")
          console.log("小睡眠用户信息：",info.data);
          if(info.status === 1){
            // localStorage.setItem("openid",info.data.openid)
            store.commit("setCosleepOpenid",info.data.openid)
            store.commit("setCosleepUserInfo",info.data)
            resolve(true)
          }else{
            resolve(false)
          }
        })
      })
    }

    // 有没有登录呀
    static islogin(){
      return new Promise((resolve,rej)=>{
        this.callAppRouter("isLogin",{},async (error,res)=>{
          const obj = JSON.parse(res)
          console.log("是否登录：",obj);
          const islogin = obj.status === 2?false:true
          resolve(islogin)
          
        })
          
      })
    }

    static callAppRouterSync(method, params = {}, callback){
      return new Promise((resolve, reject) => {
        let req = {
          'Method': method,
          'Data': params
        }, cbName = `CB_${Date.now()}_${Math.ceil(Math.random() * 10)}`;
        req = JSON.stringify(req);
        Xinchao.Web[cbName] = (err, result) => {
          delete Xinchao.Web[cbName];
          if (err) {
            console.log('callAppRouter Error',err)
            reject(err);
          } else {
            if (typeof result === 'string') {
              // 部分用户昵称带有\n，会导致JSON.parse抛出异常
              // 不要使用replaceAll，在一些低版本机型中会存在兼容性问题：replaceAll is not a function
              result = result.replace(/\n/g, "");
              result = JSON.parse(result);
            }
            resolve(result);
          }
        };
        if (/(iPhone|iPad|iPod)/i.test(navigator.userAgent)) {
          window.webkit.messageHandlers.XinchaoApp.postMessage({req, cbName});
        } else {
          window.XinchaoApp.callRouter(req, cbName);
        }
      });

    }
  



    static callAppRouter (method, params={}, callback) {
        try {
          let req = {
            'Method': method,
            'Data': params
          },cbName = `CB_${Date.now()}_${Math.ceil(Math.random() * 10)}`;

          req=JSON.stringify(req);
          Xinchao.Web[cbName] =  (err, result) => {
            if(callback){
              callback(err, result);
            }
            delete Xinchao.Web[cbName];
          };
          if (/(iPhone|iPad|iPod)/i.test(navigator.userAgent)) {
            window.webkit.messageHandlers.XinchaoApp.postMessage({req, cbName});
          } else {
            try {
              XinchaoApp.callRouter(req, cbName); 
            } catch (e) {
              window.webkit.messageHandlers.XinchaoApp.postMessage({req, cbName});
            }
          }
        } catch (e) {
    
        }
      }


}